import React, { CSSProperties, FC } from 'react'

import { useTranslation } from 'react-i18next'

import { PageTemplate } from '../../PageTemplate'
import { AppCard } from './AppCard'
import { useInterconnectedApps } from './InterconnectedApps.hooks'
import styles from './InterconnectedApps.module.scss'
import { InterconnectedAppsProps } from './InterconnectedApps.types'

const APP_CARD_ANIMATION_DELAY_SECONDS = 0.7

export const InterconnectedApps: FC<InterconnectedAppsProps> = ({
  setActivePage
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'product_tour.interconnected_apps'
  })

  const isPersonal = true // TODO: make this dynamic
  const { organizationTourApps, personalTourApps } = useInterconnectedApps()

  const displayedApps = isPersonal ? personalTourApps : organizationTourApps

  return (
    <PageTemplate
      className={styles.interconnectedApps}
      navigationProps={{
        currentPage: 1,
        buttonLabel: t('navigate'),
        setActivePage,
        animationDelay:
          (displayedApps.length - 1) * APP_CARD_ANIMATION_DELAY_SECONDS
      }}
    >
      <div className={styles.texts}>
        <h1>{t('title')}</h1>
        <span>{t('description')}</span>
      </div>
      <div className={styles.appCards}>
        {displayedApps.map((app, i) => (
          <AppCard
            key={app.name}
            app={app}
            className={styles.appCard}
            style={
              {
                '--animation-delay': `${i * APP_CARD_ANIMATION_DELAY_SECONDS}s`
              } as CSSProperties
            }
          />
        ))}
      </div>
    </PageTemplate>
  )
}
